/**
 * @module Components.SignUp
 *
 * Informational dead end shown when an athlete/parent says their coach
 * invited them. There is intentionally no forward CTA — the only way to
 * continue is to join through the coach's invite. Back returns to the
 * "Were you invited?" gate.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type PropsDef = {
  onBack: () => void;
};

export default function InviteDeadEnd(props: PropsDef) {
  const { t } = useTranslation();

  // Built inside the component so t() runs in a translation context.
  const steps: string[] = [
    t("Your coach sends you an invite from their CoachNow app."),
    t("You receive an email with a personal invite link."),
    t("Tap the link to join your coach's Space — free, no payment needed."),
  ];

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={styles.back}
        onClick={props.onBack}
        aria-label={t("Back")}
      >
        <i className="fas fa-arrow-left" aria-hidden="true" />
        {t("Back")}
      </button>

      <h2 className={styles.title}>
        {t("Check with your coach for an invite")}
      </h2>
      <p className={styles.subtitle}>
        {t(
          "When your coach invites you through CoachNow, you get full access for free — everything is set up automatically.",
        )}
      </p>

      <ol className={styles.steps}>
        {steps.map((step, index) => (
          <li key={index} className={styles.step}>
            <span className={styles.step_number}>{index + 1}</span>
            <span className={styles.step_title}>{step}</span>
          </li>
        ))}
      </ol>

      <p className={styles.note}>
        {t("If you have questions, please contact your coach directly.")}
      </p>
    </div>
  );
}
